/* eslint-disable react/prop-types */ // TODO: add props
import PropTypes from 'prop-types';
import { Children } from 'react';
import _ from 'lodash';
import withSideEffect from 'react-side-effect';

const reducePropsToState = (propsList) =>
  _.uniq(propsList.map((props) => props.className)).join(' ');
const handleStateChangeOnClient = (stringClassNames) => {
  document.documentElement.className = stringClassNames || '';
};

const HtmlClassName = ({ children, className = '' }) => {
  return children ? Children.only(children) : null;
};
HtmlClassName.propTypes = {
  className: PropTypes.string.isRequired,
};

export default withSideEffect(
  reducePropsToState,
  handleStateChangeOnClient
)(HtmlClassName);
